"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_pdf_1 = require("react-pdf");
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const styles_1 = __importDefault(require("./styles"));
react_pdf_1.pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${react_pdf_1.pdfjs.version}/pdf.worker.js`;
const CreatePages = (pageCount, page, pdfWrapperRef, scale) => {
    var _a;
    const pages = [];
    for (let i = page * 10 + 1; i <= page * 10 + 10; i += 1) {
        if (i > pageCount)
            break;
        pages.push(react_1.default.createElement(react_pdf_1.Page, { loading: react_1.default.createElement(core_1.LinearProgress, { color: "primary" }), options: {
                cMapPacked: true,
                cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${react_pdf_1.pdfjs.version}/cmaps/`,
            }, pageNumber: i, renderAnnotationLayer: false, renderMode: "canvas", renderTextLayer: false, scale: scale, width: ((_a = pdfWrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) * 0.95 }));
    }
    return pages;
};
const PDFViewer = ({ file }) => {
    const classes = styles_1.default();
    const [pageCount, setPageCount] = react_1.useState(0);
    const [scale, setScale] = react_1.useState(1);
    const { t: translate } = react_i18next_1.useTranslation();
    const pdfWrapperRef = react_1.default.useRef();
    const fileOrBase64 = file.toLowerCase().endsWith('.pdf')
        ? file
        : `data:application/pdf;base64,${file}`;
    const onDocumentLoadSuccess = ({ numPages }) => {
        setPageCount(numPages);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.zoomNavigatorContainer },
            react_1.default.createElement(core_1.IconButton, { "aria-label": "zoom_out", disabled: scale <= 1, onClick: () => setScale(scale - 0.2) },
                react_1.default.createElement(icons_1.RemoveCircle, null)),
            react_1.default.createElement("span", null,
                translate('common.pdf.title'),
                ":",
                react_1.default.createElement("b", null,
                    Math.round(scale * 100),
                    "%")),
            react_1.default.createElement(core_1.IconButton, { "aria-label": "zoom_in", disabled: scale >= 3, onClick: () => setScale(scale + 0.2) },
                react_1.default.createElement(icons_1.AddCircle, null))),
        react_1.default.createElement("div", { className: classes.container, ref: pdfWrapperRef },
            react_1.default.createElement(react_pdf_1.Document, { file: fileOrBase64, loading: react_1.default.createElement(core_1.LinearProgress, { color: "primary" }), onLoadSuccess: onDocumentLoadSuccess, options: {
                    cMapUrl: 'cmaps/',
                    cMapPacked: true,
                } }, CreatePages(pageCount, 0, pdfWrapperRef, scale).map((page, index) => (react_1.default.createElement("div", { key: `pdf-viewer-key-${index}` }, page)))))));
};
exports.default = react_1.memo(PDFViewer);
